export abstract class VatDeclarationPeriod{
	public Year:number = new Date().getFullYear()
	public abstract getJSON():any;
	public abstract toString():string;
}